export default function blogList() {
  return {
    _id: false,
    type: 'droplet.blogList',
    mediaQueries: [],
    visible: 6,
    showImage: true,
    loadMoreText: 'Load More',
    pageCSS: '',
    bounceDroplet: false,
    isShared: false,
    templateRegion: false,
  };
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/blog-list/droplet.schema.js